// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogFullDiv
{
    position:fixed;
    top:0px;
    left:0px;
    width: 100%;
    height: 100%;
    background-color: #00000000;
    -webkit-user-select: none;
            user-select: none;
    text-align: left;
}

.dialogInterneDiv
{
    position: fixed;
    background-color: var(--dialog-content-backcolor);
    color: white;
    border-radius : 8px;
    flex-direction: column;
    -webkit-user-select: none;
            user-select: none;
    text-align: left;
    border: solid;
    border-width: 2px;
    border-color: var(--default-icon-color);
    

}

.dialogTitle
{
    padding-top: 5px;
    background-color: var(--dialog-title-backcolor);
    border-top-left-radius : 8px;
    border-top-right-radius : 8px;
    color: white;
    height: 30px;
    font-size: 15px;
    text-align: center;
    display: flex;
}
.dialogTitleCloseButton
{
    width: 30px;
    background-color: transparent;
}
.dialogTitleText
{
    background-color: transparent;
    width: calc(100% - 30px);

}


.dialogSectionZone
{
    background-color: transparent;
    width: calc(100% - 20px);
    border-radius: 6px;
    border-style: solid;
    border-color: #A0A0A0;
    border-width: 1px;
    margin-left: 5px;
    padding-bottom: 10px;
    padding-top: 10px;
    margin-bottom: 10px;
    
}


.dialogButtonsDiv
{
    padding-top: 10px;
    padding-bottom: 5px;
    
    background-color: var(--dialog-buttons-backcolor);
    border-bottom-left-radius : 8px;
    border-bottom-right-radius : 8px;
    color: white;
    height: 40px;
    font-size: 15px;
    
    margin-top: 5px;
    text-align: right;
    
}


.dialog-Input-Title
{
    text-align: left;
    margin-top: 5px;
    margin-bottom: 3px;
    margin-left: 10px;
    font-size: 14px;
    color: gray;
}

.dialog-Label-Title
{
    vertical-align: middle;
    margin-top: 18px;
    margin-bottom: 10px;
    text-align: center;
    margin-left: 10px;
    font-size: 14px;
    background-color: #202020;
    border-radius: 4px;
    color:white;
}



.dialog-InputBoxText
{
    text-align: left;
    font-size: 14px;
    color: #909090;
    
}


.dialog-InputBox{
    margin-left: 10px;
    padding-top: 5px;
    vertical-align: middle;
}
.dialog-Input-Datas
{
    font-size: 15px;
    margin-left: 10px;
    margin-right: 10px;
    color: white;
    background-color: black;
    border: 1px solid #404040; /* Flat border */
    outline: none;          /* Removes focus outline */
    box-shadow: none;       /* Removes shadow effects */
    appearance: none;       /* Removes browser-specific styling */
    -webkit-appearance: none; /* Removes WebKit-specific styling */
    -moz-appearance: none;    /* Removes Mozilla-specific styling */
}

.dialog-Input-Datas-Multiline
{
    font-size: 15px;
    margin-left: 10px;
    margin-right: 10px;
    color: white;
    background-color: black;
    border: 1px solid #404040; /* Flat border */
    outline: none;          /* Removes focus outline */
    box-shadow: none;       /* Removes shadow effects */
    appearance: none;       /* Removes browser-specific styling */
    -webkit-appearance: none; /* Removes WebKit-specific styling */
    -moz-appearance: none;    /* Removes Mozilla-specific styling */
}


/* largeur de la scrollbar */
.dialog-Input-Datas-Multiline::-webkit-scrollbar {
  width: 6px;
}

/* fond (optionnel) */
.dialog-Input-Datas-Multiline::-webkit-scrollbar-track {
  background: transparent;
}

/* le "trait" coloré */
.dialog-Input-Datas-Multiline::-webkit-scrollbar-thumb {
  background-color: var(--default-icon-color);
  border-radius: 3px;
}




.dialog-Table-Datas
{

    
    font-size: 15px;
    margin-left: 10px;
    margin-right: 10px;
    color: white;
    background-color: black;
    border: 1px solid #404040; /* Flat border */
}


.dialog-upload-zone
{
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    height: 100px; 
    font-size: 10px;
    border: 2px dashed #ccc; 
    text-align: center;
    justify-content: center; 
    align-items: center;
    
}

`, "",{"version":3,"sources":["webpack://./src/applications/dialogs/dialog.css"],"names":[],"mappings":"AAAA;;IAEI,cAAc;IACd,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,uCAAuC;;;AAG3C;;AAEA;;IAEI,gBAAgB;IAChB,+CAA+C;IAC/C,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;AACA;;IAEI,WAAW;IACX,6BAA6B;AACjC;AACA;;IAEI,6BAA6B;IAC7B,wBAAwB;;AAE5B;;;AAGA;;IAEI,6BAA6B;IAC7B,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;;AAEvB;;;AAGA;;IAEI,iBAAiB;IACjB,mBAAmB;;IAEnB,iDAAiD;IACjD,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,eAAe;;IAEf,eAAe;IACf,iBAAiB;;AAErB;;;AAGA;;IAEI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;;;AAIA;;IAEI,gBAAgB;IAChB,eAAe;IACf,cAAc;;AAElB;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;;IAEI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB,EAAE,gBAAgB;IAC3C,aAAa,WAAW,0BAA0B;IAClD,gBAAgB,QAAQ,2BAA2B;IACnD,gBAAgB,QAAQ,qCAAqC;IAC7D,wBAAwB,EAAE,oCAAoC;IAC9D,qBAAqB,KAAK,qCAAqC;AACnE;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB,EAAE,gBAAgB;IAC3C,aAAa,WAAW,0BAA0B;IAClD,gBAAgB,QAAQ,2BAA2B;IACnD,gBAAgB,QAAQ,qCAAqC;IAC7D,wBAAwB,EAAE,oCAAoC;IAC9D,qBAAqB,KAAK,qCAAqC;AACnE;;;AAGA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;;;;AAKA;;;;IAII,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB,EAAE,gBAAgB;AAC/C;;;AAGA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;AAEvB","sourcesContent":[".dialogFullDiv\n{\n    position:fixed;\n    top:0px;\n    left:0px;\n    width: 100%;\n    height: 100%;\n    background-color: #00000000;\n    user-select: none;\n    text-align: left;\n}\n\n.dialogInterneDiv\n{\n    position: fixed;\n    background-color: var(--dialog-content-backcolor);\n    color: white;\n    border-radius : 8px;\n    flex-direction: column;\n    user-select: none;\n    text-align: left;\n    border: solid;\n    border-width: 2px;\n    border-color: var(--default-icon-color);\n    \n\n}\n\n.dialogTitle\n{\n    padding-top: 5px;\n    background-color: var(--dialog-title-backcolor);\n    border-top-left-radius : 8px;\n    border-top-right-radius : 8px;\n    color: white;\n    height: 30px;\n    font-size: 15px;\n    text-align: center;\n    display: flex;\n}\n.dialogTitleCloseButton\n{\n    width: 30px;\n    background-color: transparent;\n}\n.dialogTitleText\n{\n    background-color: transparent;\n    width: calc(100% - 30px);\n\n}\n\n\n.dialogSectionZone\n{\n    background-color: transparent;\n    width: calc(100% - 20px);\n    border-radius: 6px;\n    border-style: solid;\n    border-color: #A0A0A0;\n    border-width: 1px;\n    margin-left: 5px;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    margin-bottom: 10px;\n    \n}\n\n\n.dialogButtonsDiv\n{\n    padding-top: 10px;\n    padding-bottom: 5px;\n    \n    background-color: var(--dialog-buttons-backcolor);\n    border-bottom-left-radius : 8px;\n    border-bottom-right-radius : 8px;\n    color: white;\n    height: 40px;\n    font-size: 15px;\n    \n    margin-top: 5px;\n    text-align: right;\n    \n}\n\n\n.dialog-Input-Title\n{\n    text-align: left;\n    margin-top: 5px;\n    margin-bottom: 3px;\n    margin-left: 10px;\n    font-size: 14px;\n    color: gray;\n}\n\n.dialog-Label-Title\n{\n    vertical-align: middle;\n    margin-top: 18px;\n    margin-bottom: 10px;\n    text-align: center;\n    margin-left: 10px;\n    font-size: 14px;\n    background-color: #202020;\n    border-radius: 4px;\n    color:white;\n}\n\n\n\n.dialog-InputBoxText\n{\n    text-align: left;\n    font-size: 14px;\n    color: #909090;\n    \n}\n\n\n.dialog-InputBox{\n    margin-left: 10px;\n    padding-top: 5px;\n    vertical-align: middle;\n}\n.dialog-Input-Datas\n{\n    font-size: 15px;\n    margin-left: 10px;\n    margin-right: 10px;\n    color: white;\n    background-color: black;\n    border: 1px solid #404040; /* Flat border */\n    outline: none;          /* Removes focus outline */\n    box-shadow: none;       /* Removes shadow effects */\n    appearance: none;       /* Removes browser-specific styling */\n    -webkit-appearance: none; /* Removes WebKit-specific styling */\n    -moz-appearance: none;    /* Removes Mozilla-specific styling */\n}\n\n.dialog-Input-Datas-Multiline\n{\n    font-size: 15px;\n    margin-left: 10px;\n    margin-right: 10px;\n    color: white;\n    background-color: black;\n    border: 1px solid #404040; /* Flat border */\n    outline: none;          /* Removes focus outline */\n    box-shadow: none;       /* Removes shadow effects */\n    appearance: none;       /* Removes browser-specific styling */\n    -webkit-appearance: none; /* Removes WebKit-specific styling */\n    -moz-appearance: none;    /* Removes Mozilla-specific styling */\n}\n\n\n/* largeur de la scrollbar */\n.dialog-Input-Datas-Multiline::-webkit-scrollbar {\n  width: 6px;\n}\n\n/* fond (optionnel) */\n.dialog-Input-Datas-Multiline::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* le \"trait\" coloré */\n.dialog-Input-Datas-Multiline::-webkit-scrollbar-thumb {\n  background-color: var(--default-icon-color);\n  border-radius: 3px;\n}\n\n\n\n\n.dialog-Table-Datas\n{\n\n    \n    font-size: 15px;\n    margin-left: 10px;\n    margin-right: 10px;\n    color: white;\n    background-color: black;\n    border: 1px solid #404040; /* Flat border */\n}\n\n\n.dialog-upload-zone\n{\n    margin-right: 10px;\n    margin-left: 10px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    height: 100px; \n    font-size: 10px;\n    border: 2px dashed #ccc; \n    text-align: center;\n    justify-content: center; \n    align-items: center;\n    \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
